import {
  ApiConfigResponse,
  AppConfig,
  ENVIRONMENT,
  WEB_DOMAIN_URL_MAP,
  API_BASE_URL,
  BaseAppConfig,
  VERSION,
  APP_ID
} from '../domain/config'

export const isDevEnvironment = (domain: string): boolean => {
  return (
    domain === WEB_DOMAIN_URL_MAP.get(ENVIRONMENT.LOCAL) ||
    domain === WEB_DOMAIN_URL_MAP.get(ENVIRONMENT.DEVELOPMENT)
  )
}

export const isQaEnvironment = (domain: string): boolean =>
  domain === WEB_DOMAIN_URL_MAP.get(ENVIRONMENT.QA)

export const isProdEnvironment = (domain: string): boolean =>
  domain === WEB_DOMAIN_URL_MAP.get(ENVIRONMENT.PRODUCTION)

export const getDefault = (): AppConfig => {
  return buildConfig(setEnvironmentBaseConfig(getEnvironmentFromUrl()), {
    AMPLITUDE_API_KEY: '',
    BRANCH_API_KEY: '',
    SOCURE_PUBLIC_KEY: ''
  })
}

export const getEnvironmentFromUrl = (): ENVIRONMENT => {
  if (isDevEnvironment(window.location.hostname)) {
    return ENVIRONMENT.DEVELOPMENT
  }
  if (isQaEnvironment(window.location.hostname)) {
    return ENVIRONMENT.QA
  }
  if (isProdEnvironment(window.location.hostname)) {
    return ENVIRONMENT.PRODUCTION
  }
  return ENVIRONMENT.DEVELOPMENT
}

export const setEnvironmentBaseConfig = (
  environment: ENVIRONMENT
): BaseAppConfig => {
  return {
    apiUrl: buildBaseUrl(environment),
    environment
  }
}

export const buildBaseUrl = (environment?: ENVIRONMENT): string => {
  const env = environment || getEnvironmentFromUrl()
  return `${API_BASE_URL[env].baseUrl}/${API_BASE_URL[env].stage}`
}

export const buildConfig = (
  base: BaseAppConfig,
  response: ApiConfigResponse
): AppConfig => ({ ...base, variables: { ...mapConfig(response) } })

const mapConfig = (response: ApiConfigResponse): ApiConfigResponse => {
  return {
    AMPLITUDE_API_KEY: response.AMPLITUDE_API_KEY,
    BRANCH_API_KEY: response.BRANCH_API_KEY,
    SOCURE_PUBLIC_KEY: response.SOCURE_PUBLIC_KEY,
    promotionOverrides: response.promotionOverrides
  }
}

export const fetchConfig = (): Promise<ApiConfigResponse> => {
  return fetch(`https://${buildBaseUrl()}/config/${APP_ID}/${VERSION}`, {
    cache: 'no-cache'
  }).then((response) => response.json())
}
